import { render, staticRenderFns } from "./ui-radio-group.vue?vue&type=template&id=3ef0fa16&scoped=true&"
import script from "./ui-radio-group.vue?vue&type=script&lang=ts&"
export * from "./ui-radio-group.vue?vue&type=script&lang=ts&"
import style0 from "./ui-radio-group.vue?vue&type=style&index=0&id=3ef0fa16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0fa16",
  null
  
)

export default component.exports